export default __webpack_public_path__ + "static/G6_ND_25_2021RGB2Spiral-01 - Copy-sp-2000ceff093cd25ef5fdf1fd72b0fb9b.svg";